import { Component } from '@angular/core';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';
import { TabComponent } from '../../../../components/tab/tab.component';
import { BaseDraftTabComponent } from '../base-draft-tab.component';
import { ButtonDirective } from '../../../../components/button/button.directive';
import { NgIcon } from '@ng-icons/core';
import { ModalComponent } from '../../../../components/modal/modal.component';
import { DraftActionType } from '../../../../interfaces/apis/customer-drafts';

@Component({
  selector: 'app-draft-deletion-tab',
  imports: [
    TabLayoutComponent,
    APITableComponent,
    ButtonDirective,
    NgIcon,
    ModalComponent,
  ],
  providers: [
    { provide: TabComponent, useExisting: DraftDeletionTabComponent },
  ],
  templateUrl: './draft-deletion-tab.component.html',
  styleUrl: './draft-deletion-tab.component.scss',
})
export class DraftDeletionTabComponent extends BaseDraftTabComponent {
  override name = this.dictionaryService.get('Deletion');
  readonly draftAction: DraftActionType = 'Deletion';
}
